module.exports = __webpack_public_path__ + "img/ios-toolbar.d84e42ec.jpg";